import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AgendamentoDespesaListarRoutingModule } from "./agendamento-despesa-listar-routing.module";
import { AgendamentoDespesaListarComponent } from "./agendamento-despesa-listar.component";

import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { SplitButtonModule } from 'primeng/splitbutton';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from "primeng/api";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { CalendarModule } from "primeng/calendar";




@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        RippleModule,        
        ChipModule,
        TableModule,
        EditorModule,
        AgendamentoDespesaListarRoutingModule,    
        HttpClientModule,        
        TooltipModule,
        DividerModule,
        SplitButtonModule,
        ConfirmDialogModule,
        DropdownModule,
        CalendarModule
    ],
    providers: [ConfirmationService],
    declarations: [AgendamentoDespesaListarComponent]
})
export class AgendamentoDespesaListarModule { }
